import { useEffect } from 'react';

// Terms of Service is canonical on the marketing site.
// Any direct visit to app.solem.ai/terms hops to www.solem.ai/terms.
export function Terms() {
  useEffect(() => {
    window.location.replace('https://www.solem.ai/terms');
  }, []);
  return null;
}
